import {Field} from 'formik'

interface ControlledInputProps {
  name: string
  type: string
  setFieldValue: (name: string, value: string) => void;
  id?: string;
  placeholder?: string
  className?: string
  regex?: RegExp
  maxLength?: number
  value?: any;
}

const regexMap: Record<string, RegExp> = {
    // for text fields allows only .’'-/ and english letters
    text: /[^A-Za-z.'’\-\/ ]+/g
}

export default function ControlledInput ({
  name,
  id,
  type,
  setFieldValue,
  placeholder,
  className,
  regex,
  maxLength,
  value
}: ControlledInputProps) {

return (
    <Field
        name={name}
        id={id}
        className={`form-control bg-transparent text-black${className ? ` ${className}` : ''}`}
        type={type}
        placeholder={placeholder}
        maxLength={maxLength ? maxLength : 100}
        defaultValue={value}
        onChange={(event) => {
            const {value} = event.target;
            const filterRegex = regex || regexMap[type];
            const filtered = filterRegex ? value?.replace(filterRegex, '') : value;
            setFieldValue(name, filtered)
        }}
    />
    )
}